/// <reference types="@angular/localize" />
import { bootstrapApplication } from '@angular/platform-browser';
import { App } from 'src/app/app';
import { appConfig } from 'src/app/app.config';

bootstrapApplication(App, appConfig).catch((error: unknown): void => {
    console.error(error);
});
